export default __webpack_public_path__ + "static/media/logo-riverside.323de7da.png";